module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tool":"Tool","pan":"Pan","rectangle_selection_(press_shift_key)":"Rectangle Selection (Press Shift Key)","linear_selection_(press_meta_key)":"Linear Selection (Press Meta Key)"},"ja":{"tool":"ツール","pan":"移動","rectangle_selection_(press_shift_key)":"矩形選択 (shiftキー)","linear_selection_(press_meta_key)":"線形選択 (metaキー)"}}')
  delete Component.options._Ctor
}
